
<template>
  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">
      <!--go back  -->
      <div class="w-full  h-10 ">
        <div class="flex items-center justify-center bg-primary w-10 h-full hover:bg-trader-blue" @click="goBack">
          <i class="fa-solid fa-arrow-left text-black text-xl"></i>
        </div>
      </div>
      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex  text-center justify-center">
        <div class=" overflow-auto bg-white rounded p-10  max-w-[1000px] flex-grow">
          <div class="flex-grow flex flex-col container mx-auto bg-white rounded p-2 ">
            <div class="flex-shrink-0 flex items-center justify-between w-full h-10 mb-4 rounded">
              <div class="w-full bg-primary p-2 rounded">
                <span class="text-xl">Erstellen</span>
              </div>
            </div>
            <div class="flex w-full overflow-y-auto h-[800px]">
              <div class="w-full">
                <div class="flex ">
                  <div class="w-1/3 bg-primary text-center h-10 flex items-center justify-center">Namen:</div>
                  <input class="w-2/3 p-1 border border-bg-trader-input-border" v-model="fieldName" data-ui="input-title-of-new-productfield">
                </div>
                <div class=" ">
                  <button class="w-full rounded mt-2 p-3 bg-primary hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out" @click="creatCustomField" data-ui="button-create-new-productfield">
                    Produkt Feld Erstellen
                  </button>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <sidebar />

  </div>
</template>

<script >
import sidebar from "@/components/Administration/Sidebar.vue";
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import router from "@/router";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
export default {

  components:{sidebar},
  data(){
    return{
      fieldName: '',
      accordionIndex: 0,
    }
  },
  methods:{
    goBack(){
      router.push("/administration")
    },
    async creatCustomField() {
      const customData = {
        productFieldId: 0,
        fieldName: this.fieldName,
        dontCopy: false,
        ignoreOnPlaceProduct: false,

      }
      const mutation = gql`
        mutation creatCustomField($customField: CustomFieldInput!) {
           creatCustomField(customField: $customField) {
            success
          }
        }
      `;

      try {
        const variables = {
          customField: customData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        if (data.creatCustomField.success){
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Produktfeld erstellt",
            message: "Das Produktfeld wurde erstellt",
          });
          router.push(`/administration/${this.accordionIndex}`);
        }
      } catch (error) {
        console.error(error);

      }

    },

  },
  watch: {
    // get accordionIndex from url
    '$route.params.accordionIndex': function (newId, oldId) {
      this.accordionIndex = newId;
    },
  },
  created() {
    this.accordionIndex = this.$route.params.accordionIndex;
  }
}
</script>

